import { V1Sites } from '../api'
import { database } from '../firebase.service'
import * as actions from '../../modules/actions'
import { MigrationBase } from './base'

const db = database()

export class SiteMigration extends MigrationBase {
  private readonly siteData: any
  private readonly currentProductVersion: number
  private readonly userProductVersion: number
  private readonly isGridBuilder: boolean
  private readonly siteAPI: V1Sites
  private modelStatusRef: any

  constructor({
    siteData,
    currentProductVersion,
    userProductVersion,
    isGridBuilder,
  }: any) {
    super()
    this.siteData = siteData
    this.currentProductVersion = currentProductVersion
    this.userProductVersion = userProductVersion
    this.isGridBuilder = isGridBuilder
    this.siteAPI = new V1Sites()
    this.modelStatusRef = null
  }

  async runMigration() {
    if (!this.isGridBuilder) {
      throw new Error('Migration only supported for grid builder')
    }

    if (this.currentProductVersion >= this.userProductVersion) {
      throw new Error('No migration needed')
    }

    this.setMessageLog('Getting Ready to migrate site data...')

    const { completed, failed = false } = await this.setDefaultStatus(
      this.siteData.firebaseRef,
    )

    if (completed || failed) {
      if (failed) {
        throw new Error('Migration already failed')
      }
      return // Already completed
    }

    this.setMessageLog('Initiating site data migration...')

    await this.waitForAWhile(2000)

    await this.waitForMigrationStatus(this.siteData.firebaseRef)

    return this.siteAPI.runDataStructureMigration({
      modelRef: this.siteData.firebaseRef,
      fromVersion: this.currentProductVersion,
      toVersion: this.userProductVersion,
      siteId: this.siteData.id,
    })
  }

  async setDefaultStatus(firebaseRef: any) {
    const modelStatusRef = db.ref(firebaseRef).child('migrationStatus')

    const value = await modelStatusRef.once('value')
    if (!value.exists()) {
      return {
        log: [
          {
            message: 'Initializing...',
          },
        ],
        completed: false,
      }
    }
    return value.val()
  }

  waitForMigrationStatus(firebaseRef: any) {
    return new Promise((resolve, reject) => {
      this.modelStatusRef = db.ref(firebaseRef).child('migrationStatus')

      this.modelStatusRef.on('value', (snap: any) => {
        if (snap.exists()) {
          const { completed, failed, log } = snap.val()
          const lastLog = Object.values(log).pop() as { message: string }
          this.setMessageLog(lastLog.message)

          if (completed) {
            this.modelStatusRef.off('value')
            this.modelStatusRef.remove()
            resolve('completed')
          } else if (failed) {
            this.modelStatusRef.off('value')
            reject(new Error('Migration failed'))
          }
        }
      })
    })
  }

  async onCompleted() {
    await this.$store.dispatch(
      actions.SITE_FETCH_DATA,
      this.$route.params.siteId,
    )
    this.cleanup()
  }

  cleanup() {
    if (this.modelStatusRef) {
      this.modelStatusRef.off('value')
    }
  }
}
